import { writable, derived } from "svelte/store";
export const jwt = writable(localStorage.jwt);
function parseJwt(token) {
    if (!token)
        return null;
    try {
        return JSON.parse(atob(token.split('.')[1]));
    }
    catch (_a) {
        return null;
    }
}
export const jwtPayload = derived(jwt, ($jwt) => parseJwt($jwt));
export async function logout() {
    let result = await authFetch('/logout', {
        method: 'GET',
        headers: {
            "content-type": "application/json"
        }
    });
    if (result.ok) {
        localStorage.removeItem('jwt');
        jwt.set(null);
    }
    else {
        alert(result.statusText);
    }
}
export async function login(username, password) {
    let result = await fetch('/login', {
        method: 'POST',
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ username, password })
    });
    if (result.ok) {
        let token = (await result.json()).token;
        localStorage.setItem('jwt', token);
        jwt.set(token);
    }
    else {
        alert(result.statusText);
    }
}
export async function authBlobUrl(input, init = {}) {
    let response = await authFetch(input, init);
    if (response.ok) {
        let blob = await response.blob();
        return window.URL.createObjectURL(blob);
    }
    else {
        // console.error(response.statusText)
        return null;
    }
}
export function authFetch(input, init = {}) {
    var _a;
    let headers = (_a = init.headers) !== null && _a !== void 0 ? _a : {};
    headers["Authorization"] = `Bearer ${localStorage.jwt}`;
    init.headers = headers;
    return fetch(input, init).then((response) => {
        if (response.status === 403) {
            localStorage.removeItem('jwt');
            jwt.set(null);
        }
        return response;
    });
}
